import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

export const isEditingLinkAtomFamily = atomFamily((nodeId: string) => {
  const isEditingAtom = atom(false);
  isEditingAtom.debugLabel = `isEditingLinkAtomFamily(${nodeId})`;
  return isEditingAtom;
});
